export default function HowItWorks() {
  const steps = [
    {
      number: "1",
      title: "Create an Account",
      description:
        "Sign up and submit the channels or content you want to protect.",
    },
    {
      number: "2",
      title: "Detect Unauthorized Use",
      description:
        "Our system scans for reuploads of your videos across YouTube 24/7.",
    },
    {
      number: "3",
      title: "Claim & Monetize",
      description:
        "We enforce your rights and redirect ad revenue from those reuploads to you.",
    },
  ];

  return (
    <div id="how-it-works" className="bg-white py-40 pb-44 px-6 md:px-16">
      <div className="4xl:max-w-[100rem] 4xl:mx-auto">
        <div className="text-center mb-12">
          <p className="text-[#FF6B35] font-semibold text-xl uppercase tracking-wide mb-4">
            SIMPLE PROCESS
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-gray-900">
            How does it work?
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-20 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="text-center space-y-3">
              <div className="flex justify-center !mb-6">
                <div className="w-16 h-16 bg-gradient-to-b from-[#FF8C5F] to-[#FF6B35] rounded-full flex items-center justify-center">
                  <span className="text-3xl font-bold text-white">
                    {step.number}
                  </span>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 lg:text-nowrap">{step.title}</h3>
              <p className="leading-relaxed max-w-[230px] mx-auto">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
